/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetTypeModel } from './PetTypeModel';
import {
    PetTypeModelFromJSON,
    PetTypeModelFromJSONTyped,
    PetTypeModelToJSON,
} from './PetTypeModel';

/**
 * 
 * @export
 * @interface PetRidingStyleModel
 */
export interface PetRidingStyleModel {
    /**
     * 
     * @type {number}
     * @memberof PetRidingStyleModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PetRidingStyleModel
     */
    name?: string;
    /**
     * Only modifiable during update.
     * @type {boolean}
     * @memberof PetRidingStyleModel
     */
    markForDelete?: boolean;
    /**
     * 
     * @type {PetTypeModel}
     * @memberof PetRidingStyleModel
     */
    type?: PetTypeModel;
}

/**
 * Check if a given object implements the PetRidingStyleModel interface.
 */
export function instanceOfPetRidingStyleModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetRidingStyleModelFromJSON(json: any): PetRidingStyleModel {
    return PetRidingStyleModelFromJSONTyped(json, false);
}

export function PetRidingStyleModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetRidingStyleModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'markForDelete': !exists(json, 'markForDelete') ? undefined : json['markForDelete'],
        'type': !exists(json, 'type') ? undefined : PetTypeModelFromJSON(json['type']),
    };
}

export function PetRidingStyleModelToJSON(value?: PetRidingStyleModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'markForDelete': value.markForDelete,
        'type': PetTypeModelToJSON(value.type),
    };
}

